import type { ROW } from "@/types/form-types"
import type { UseFormReturn } from "react-hook-form"
import { Column } from "./column"

interface RowProps {
	row: ROW
	form: UseFormReturn
}

export const Row = ({ row, form }: RowProps) => {
	const gridCols =
		row.columns.length === 1
			? 1
			: row.columns.length === 2
				? 2
				: row.columns.length === 3
					? 3
					: 4

	return (
		<div
			className={`grid gap-6 ${
				gridCols === 1
					? "grid-cols-1"
					: gridCols === 2
						? "grid-cols-1 md:grid-cols-2"
						: gridCols === 3
							? "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
							: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
			}`}
		>
			{row.columns.map((column, ind) => (
				<Column
					column={column}
					key={ind}
					form={form}
				/>
			))}
		</div>
	)
}
